import React, { type ReactNode } from 'react';
import { Text } from '@atlaskit/primitives';
import { Card } from '@atlaskit/smart-card';
import type { Author, IssueData } from '../../types.tsx';
import { UsernameDisplay } from '../username-display/index.tsx';

type ActivityMessageProps = {
	author: Author;
	issueData: IssueData;
	onClick: (target: 'user' | 'issue') => void;
	children: (components: { author: ReactNode; issueLink: ReactNode }) => ReactNode;
};

export const ActivityMessage = ({ author, issueData, onClick, children }: ActivityMessageProps) => {
	return (
		<Text>
			{children({
				author: (
					<UsernameDisplay
						user={author}
						onClick={() => {
							onClick('user');
						}}
					/>
				),
				issueLink: (
					<Card
						url={issueData.url}
						appearance="inline"
						platform="web"
						onClick={() => onClick('issue')}
					/>
				),
			})}
		</Text>
	);
};
